var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAtlassian = function SvgAtlassian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#atlassian_svg__a)",
    d: "M11.129 15.081c-.364-.4-.91-.364-1.165.11L4.07 26.98c-.219.473.109 1.019.618 1.019h8.188c.255 0 .51-.146.62-.4 1.782-3.64.727-9.207-2.366-12.519"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2684FF",
    d: "M15.423 4.382c-3.275 5.204-3.056 10.99-.91 15.32 2.184 4.331 3.822 7.68 3.967 7.898.11.254.364.4.619.4h8.188c.51 0 .873-.546.619-1.019 0 0-11.027-22.053-11.318-22.599-.219-.51-.837-.51-1.165 0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "atlassian_svg__a",
    x1: 14.346,
    x2: 8.132,
    y1: 16.905,
    y2: 27.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923,
    stopColor: "#2684FF"
  })))));
};
export default SvgAtlassian;